import caLogo from "../../assets/images/thirdPartyLogos/career-accelarator-test.png";
import seeULogo from "../../assets/images/thirdPartyLogos/seeu-test.png";
import bsnLogo from "../../assets/images/thirdPartyLogos/ucla-bsn.png";
import bcaLogo from "../../assets/images/thirdPartyLogos/babson-bca.png";

// Company logos mapping
export const logoMap: { [key: string]: string } = {
  "career-accelerator": caLogo,
  seeu: seeULogo,
  "ucla-bsn": bsnLogo,
  "babson-bca": bcaLogo,
};

// Company display names
export const displayNameMap: { [key: string]: string } = {
  "career-accelerator": "Career Accelerator",
  seeu: "SeeU",
  "ucla-bsn": "Bruin Strategy Network",
  "babson-bca": "Babson Consulting Association",
};

// Company descriptions for login pages
export const companyInfoMap: { [key: string]: string } = {
  "career-accelerator":
    "Founded in 2024, Career Accelerator specialize in consulting career coaching, helping students land roles at top consulting firms through personalized guidance and interview prep. Our mission is to unlock potential and drive success in the competitive consulting world.",
  seeu: "SeeU helps students prepare for careers in consulting through practical training and interview preparation.",
  "ucla-bsn":
    "Bruin Strategy Network (formerly CYC at UCLA) offers managment and healthcare consulting for companies ranging from start-ups to Fortune 500!",
  "babson-bca":
    "Babson Consulting Association empowers students through consulting training, case competitions, and career development activities.",
};

// Logo styling for login pages
export const logoLoginClassNameMap: { [key: string]: string } = {
  "career-accelerator": "px-4 py-2 h-[4.75rem] w-auto",
  seeu: "bg-white px-3 py-2 h-[4.5rem] w-auto",
  "ucla-bsn": "bg-white px-2 py-2 h-[6.5rem] w-auto",
  "babson-bca": "bg-white px-2 py-2 h-[6.5rem] w-auto",
};

// Logo styling for headers
export const logoHeaderClassNameMap: { [key: string]: string } = {
  "career-accelerator": "h-8 w-auto",
  seeu: "h-8 w-auto",
  "ucla-bsn": "h-[3rem] w-auto rounded-md ",
  "babson-bca": "h-[3rem] w-auto rounded-md ",
};

// Company info styling for login pages
export const displayInfoClassNameMap: { [key: string]: string } = {
  "career-accelerator":
    "text-white text-center text-[13px] font-light leading-[21px] max-w-[290px]",
  seeu: "text-white text-center text-[12px] font-normal leading-[20px] max-w-[280px]",
  "ucla-bsn":
    "text-white text-center text-[14px] font-medium leading-[22px] max-w-[300px]",
  "babson-bca":
    "text-white text-center text-[14px] font-medium leading-[22px] max-w-[300px]",
};

/**
 * Get all partner configuration for a specific partner
 * @param partnerSlug The partner identifier
 * @returns All style configurations for the partner
 */
export const getPartnerHeaderConfig = (partnerSlug: string) => {
  const isValidPartner = Object.keys(logoMap).includes(partnerSlug);

  if (!isValidPartner) {
    return {
      isValidPartner: false,
      logo: null,
      displayName: null,
      companyInfo: null,
      logoLoginClassName: null,
      logoHeaderClassName: null,
      displayInfoClassName: null,
    };
  }

  return {
    isValidPartner: true,
    logo: logoMap[partnerSlug],
    displayName: displayNameMap[partnerSlug],
    companyInfo: companyInfoMap[partnerSlug] || "",
    logoLoginClassName: logoLoginClassNameMap[partnerSlug] || "",
    logoHeaderClassName: logoHeaderClassNameMap[partnerSlug] || "",
    displayInfoClassName: displayInfoClassNameMap[partnerSlug] || "",
  };
};
